// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TextRedoIconSignature {
  Element: SVGSVGElement;
}

export const TextRedoIcon: TOC<TextRedoIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M22.134 6.305L20.553 9.042C19.289 4.969 15.485 2 11 2C5.486 2 1 6.486 1 12C1 17.515 5.486 22 11 22V20C6.589 20 3 16.411 3 12C3 7.589 6.589 4 11 4C14.769 4 17.929 6.623 18.772 10.136L15.304 8.134L14.304 9.867L20.367 13.367L23.867 7.305L22.134 6.305Z"/>
</svg>
</template>;